import React, {Component} from 'react'
import { connect } from "react-redux";
import MyTable from "../../../components/TableComponents/Table";
import {
    editMediatorData,
    setDeletedMediator,
    SetMediatorsLock,
} from "../../../redux/actions/Tabs-Actions";
import MediatorEditForm from "../../../components/mediator/MediatorEditForm";
import {adminApi} from "../../../services/ApiService";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import SvGraphics from "../../../assets/SvGraphics";
import {ConstantsArrT} from "../../../utils/ConstantsWithTranslate";
import Constants from "../../../utils/constants";

class MediatorsTabConnComposed extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isSideBarOpen: false,
            entry: null
        }
    }

    async openSideBar(mediator){
        await this.setState({entry:mediator,isSideBarOpen:true})
        document.body.style.overflow = "hidden"
        this.forceUpdate();
    }

    async deleteMediatorData(mediator) {
        if(mediator && mediator.MediatorIndex){
             let deleted = await adminApi.deleteMediatorData(mediator.MediatorIndex)
            if(deleted){
                await this.props.setDeletedMediator(mediator.MediatorIndex)
            }
        }
    }
    async lockMediator(mediator) {
        if(mediator && mediator.MediatorIndex){
             let updatedMediator = await adminApi.lockMediator(mediator.MediatorIndex)
            if(updatedMediator && updatedMediator.data){
                await this.props.SetMediatorsLock(updatedMediator.data)
            }
        }
    }

    editMediatorDataDetails = async (mediator) => {
        await this.openSideBar(mediator)
    }


    setMediatorMoreFunctions = () => {
        let {t} = this.props
        return [
            {
                name: 'Edit Mediator details',
                display: t('admin.mediator.edit_mediator_details'),
                call: (MediatorIndex => this.editMediatorDataDetails(MediatorIndex))
            },
   /*         {
                name: 'Delete Mediator',
                display: t('admin.mediator.delete_mediator'),
                call: (MediatorIndex => this.deleteMediatorData(MediatorIndex))
            },*/
            {
                name: 'Lock Mediator',
                display: t('admin.mediator.lock_mediator'),
                call: (row => this.lockMediator(row))
            },
            {
                name: 'Unlock Mediator',
                display: t('admin.mediator.unlock_mediator'),
                call: (row => this.lockMediator(row))
            }
        ]
    }

    getColumns = (t) => {
        return [
            {accessor: 'MediatorCode', Header: t('admin.mediator.MediatorCode'), resizable: false},
            {accessor: 'MediatorDesc', Header: t('admin.mediator.MediatorDesc'), resizable: false},
            {accessor: 'MediatorMobile', Header: t('admin.mediator.MediatorMobile'), resizable: false},
            {accessor: 'MediatorEmail', Header: t('admin.mediator.MediatorEmail'), resizable: false},
            {accessor: 'SendNotificationToLead', Header: t('admin.mediator.SendNotificationToLead'), resizable: false,Cell: ({ original }) => {
                    if (!original.SendNotificationToLead){
                        return ''
                    } return (<SvGraphics svgname={'true'} style={{height:'15px',width:'15px', marginLeft: '19px'}}/>)
                }},
            {accessor: 'SendNotificationToPatient', Header: t('admin.mediator.SendNotificationToPatient'), resizable: false,Cell: ({ original }) => {
                    if (!original.SendNotificationToPatient){
                        return ''
                    } return (<SvGraphics svgname={'true'} style={{height:'15px',width:'15px', marginLeft: '19px'}}/>)
                },},
            {accessor: 'Enabled', Header: t('admin.mediator.locked'), resizable: false,Cell: ({ original }) => {
                    if (original.Enabled){
                        return ''
                    } return (<SvGraphics svgname={'true'} style={{height:'15px',width:'15px', marginLeft: '19px'}}/>)
                },filterConverter: ConstantsArrT(t,Constants.locked),},
        ]
    }

    render() {
        let {t} = this.props
        let {entry,isSideBarOpen} = this.state
        let columns = this.getColumns(t)
        return (
            <div className={'context-area'}>
                <MyTable
                    data={this.props.mediatorData}
                    columns={columns}
                    initialData={this.props.mediatorData}
                    onSelectionChange={null}
                    moreFunctions={this.setMediatorMoreFunctions()}
                    onFilterDataSelected={filter => this.onFilterDataSelected(filter)}
                    hasSelection={false}
                    hasMore={true}
                    hasShowInfo={false}
                />
                 {isSideBarOpen && <MediatorEditForm
                    t={e => t(e)}
                    title={t('admin.mediator.edit_mediator')}
                    entry={entry}
                    editMediatorData={mediatorData => this.props.editMediatorData(mediatorData)}
                    isSideBarOpen={isSideBarOpen}
                    closeSideBar={() => this.setState({isSideBarOpen: false})}/>}
            </div>

        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        editMediatorData: mediatorData => dispatch(editMediatorData(mediatorData)),
        setDeletedMediator: mediatorData => dispatch(setDeletedMediator(mediatorData)),
        SetMediatorsLock: mediatorData => dispatch(SetMediatorsLock(mediatorData)),
    };
}

const mapStateToProps = state => {
    return {
       mediatorData:state.mediatorTableDataReducer.mediatorData,
        initiateMediatorData:state.mediatorTableDataReducer.initiateMediatorData,
    };
};

const MediatorsTab = compose(
    withTranslation(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(MediatorsTabConnComposed);

export default MediatorsTab;
